import { type JSX } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import CameraIcon from '~/icons/camera';
import { cva } from 'class-variance-authority';
import { useIsOdesaTemplate } from '~/utilities/useIsOdesaTemplate';

const cssClasses = cva('flex items-center gap-4');

const captionClasses = cva('', {
  variants: {
    isOdesa: {
      true: 'absolute bottom-0 left-0 right-0 text-xs text-[#FFF] p-[0.75rem] text-shadow-[0_0_8px_rgba(255,255,255,1)] not-italic',
      false: '',
    },
  },
});

interface FigureWrapperProps {
  captionClass: string;
  captionAndCredit: string;
  captionIcon?: boolean;
}

export default component$<FigureWrapperProps>(
  ({ captionClass, captionAndCredit, captionIcon = false }): JSX.Element => {
    const isOdesa = useIsOdesaTemplate();
    return (
      <figure class={isOdesa ? 'relative' : ''}>
        <Slot />
        <div
          class={cssClasses({
            class: isOdesa ? captionClasses({ isOdesa: true }) : captionClass,
          })}
        >
          {captionIcon && <CameraIcon cssClasses='fill-grey' />}
          <figcaption dangerouslySetInnerHTML={captionAndCredit} />
        </div>
      </figure>
    );
  }
);
